import { useEffect } from 'react'

import ServerMaintenanceService from '~/@pages/serverMaintenance/@service/ServerMaintenance.service'

export const useServerMaintenance = () => {
  useEffect(() => {
    ServerMaintenanceService.checkServerMaintenance()
  }, [])
}
